import { currentLocale } from "@/i18n/translate";

// Dates follow the chosen website / console language.
export function formatDate(iso, withTime = true) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString(currentLocale(), withTime
    ? { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }
    : { year: "numeric", month: "short", day: "numeric" });
}

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// "never_married" -> "Never married", "3_plus" -> "3+"
export function humanize(v) {
  if (v === null || v === undefined || v === "") return "—";
  if (Array.isArray(v)) return v.length ? v.map(humanize).join(", ") : "—";
  const s = String(v).replace(/_plus$/, "+").replace(/_/g, " ");
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// banned_identifiers: [{type, value}] (tolerates an object map too) -> "phone +1555…, device abc"
export function formatIdentifiers(ids) {
  const list = Array.isArray(ids) ? ids : Object.entries(ids || {}).flatMap(([type, v]) => (Array.isArray(v) ? v : [v]).map((value) => ({ type, value })));
  return list.length ? list.map((i) => `${i.type} ${i.value}`).join(", ") : "none";
}

// 15 -> "0:15", 74.4 -> "1:14"
export function formatDuration(s) {
  if (s == null || Number.isNaN(Number(s))) return "";
  const t = Math.round(Number(s));
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`;
}

// Waiting times: whole days when divisible by 24 (72 → "3 days"), else hours (1 → "1 hour").
export function formatWait(hours) {
  const h = Number(hours);
  if (!Number.isFinite(h)) return "";
  if (h > 0 && h % 24 === 0) return `${h / 24} day${h === 24 ? "" : "s"}`;
  return `${h} hour${h === 1 ? "" : "s"}`;
}
